/**
 * accordion.js — đóng/mở accordion và lọc nhanh câu hỏi trên trang FAQs.
 *
 * Markup cần: .accordion__item > .accordion__heading > button.accordion__toggle
 *             + .accordion__panel (aria-controls trỏ tới id của panel).
 * Cho phép mở nhiều mục cùng lúc — người đọc FAQ thường so sánh vài câu một lúc.
 *
 * Viết theo cú pháp ES5 vì pipeline dùng uglify-js sau babel.
 */
(function () {
    'use strict';

    var items = [].slice.call(document.querySelectorAll('.accordion__item'));
    if (!items.length) return;

    function setOpen(item, open) {
        item.classList.toggle('is-open', open);
        var toggle = item.querySelector('.accordion__toggle');
        if (toggle) {
            toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        }
    }

    items.forEach(function (item) {
        var toggle = item.querySelector('.accordion__toggle');
        if (!toggle) return;

        toggle.addEventListener('click', function () {
            setOpen(item, !item.classList.contains('is-open'));
        });
    });

    // ----- Lọc câu hỏi theo từ khoá -----
    var search = document.querySelector('[data-faq-search]');
    if (!search) return;

    var groups = [].slice.call(document.querySelectorAll('[data-faq-group]'));
    var empty = document.querySelector('[data-faq-empty]');
    var timer;

    function filter() {
        var query = search.value.trim().toLowerCase();
        var found = 0;

        items.forEach(function (item) {
            var match = !query || item.textContent.toLowerCase().indexOf(query) !== -1;
            item.hidden = !match;
            if (match) found++;
            // Có từ khoá thì mở sẵn mục khớp để đọc ngay, xoá từ khoá thì thu lại
            if (query) setOpen(item, match);
        });

        groups.forEach(function (group) {
            group.hidden = !group.querySelector('.accordion__item:not([hidden])');

            // Ẩn luôn mục tương ứng trong mục lục để không còn link trỏ vào chỗ trống
            var heading = group.querySelector('h2');
            if (!heading || !heading.id) return;
            var link = document.querySelector('.toc__link[href="#' + heading.id + '"]');
            if (link && link.parentNode) link.parentNode.hidden = group.hidden;
        });

        if (empty) empty.hidden = found > 0;
    }

    search.addEventListener('input', function () {
        window.clearTimeout(timer);
        timer = window.setTimeout(filter, 120);
    });

    // Esc để xoá bộ lọc
    search.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' || event.key === 'Esc') {
            search.value = '';
            filter();
        }
    });
})();
